import { routers } from "@/configs";

import { Profile } from "./type";

export const VIP_STANDING_QUERY_KEY = ["vip-standing"];

export const PROFILE_ITEMS: Profile[] = [
  { id: 3, title: "profile.payment-history", icon: "card", link: routers.Transactions },
  { id: 4, title: "profile.bet-history", icon: "document", link: routers.MyBetsCasino },
  { id: 5, title: "profile.settings", icon: "settings", link: routers.SettingsAccount },
  { id: 6, title: "profile.logout", icon: "logout", link: "logout" },
];
